import React, {useEffect, useState} from 'react';
import {DemoContainer} from "@mui/x-date-pickers/internals/demo";
import {useLocation} from "react-router-dom";
import {setTaskListFilterParams} from "../../../business/redux/reducers/filter/actions";
import {openModal} from "../../../business/redux/reducers/modal/actions";
import {TaskListFilterContent} from "../../modal/informationModal/contents/taskListFilterContent";
import {useDispatch, useSelector} from "react-redux";
import {
    TextField,
    ToggleButtonGroup,
    Autocomplete,
    Badge,
    Box,
    Button,
    Chip,
    Container,
    Grid,
    ToggleButton,
    Typography,
} from "@mui/material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';
import CloseIcon from '@mui/icons-material/Close';
import {LocalizationProvider} from "@mui/x-date-pickers/LocalizationProvider";
import {DatePicker} from "@mui/x-date-pickers/DatePicker";
import {FilterAltOutlined} from "@mui/icons-material";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import moment from "moment";
import {getTaskList} from "../../../business/redux/reducers/taskReducer/actions";
import {HeaderIconsSection} from "../headerIconsSection";

const options = ["Long Distance", "Mid Distance", "Short Distance", "Local", "International"];

export const HeaderMiddleSectionFromTaskList = () => {

    const {taskListFilterParams} = useSelector(s => s.filters);
    const {taskListFilterData} = useSelector(s => s.taskReducer);
    const location = useLocation();

    const dispatch = useDispatch()
    const [jobType, setJobType] = useState([]);
    const [dateFilter, setDateFilter] = useState('all_times');
    const handleChange = (_, newDateFilter) => {
        let fromDate = moment();

        if (newDateFilter === 'all_times') {
            fromDate = moment('2000-01-01');
        } else if (newDateFilter === 'this_year') {
            fromDate = moment().startOf('year');
        } else if (newDateFilter === 'this_week') {
            fromDate = moment().startOf('week');
        } else if (newDateFilter === 'last_30_days') {
            fromDate = moment().subtract(30, 'days');
        }

        if (fromDate) {
            dispatch(setTaskListFilterParams({
                ...taskListFilterParams,
                from: fromDate.format('YYYY-MM-DD'),
                to: moment().format('YYYY-MM-DD')
            }));
        }

        setDateFilter(newDateFilter);
    };

    useEffect(() => {
        dispatch(getTaskList({filterFormData: {...taskListFilterParams, moveTypes: jobType}})).then(r => r)
    }, [dateFilter, jobType.length]);

    return(
        <>
            <Container className="statistic_filter_container" maxWidth="false"  style={{backgroundColor: '#fff',padding:'5px 8px'}}>
                <Grid container direction="row"  alignItems="center" >
                    <Grid item container direction="row" xs={2} sx={{py:0,px:1}} alignItems="center">
                        <HeaderIconsSection/>
                    </Grid>
                    <Grid item container direction="row" xs={10} sx={{py:0,px:1}} alignItems="center" justifyContent="flex-end">
                    {location.pathname === '/tasks-list' &&
                        <>
                            <Autocomplete
                                className="select_move_types"
                                sx={{'& .MuiInputBase-root':{py:0}}}
                                multiple
                                popupIcon={<KeyboardArrowDownIcon />}
                                options={taskListFilterData?.moveTypes || []}
                                value={jobType}
                                onChange={(event, newValue) => setJobType(newValue)}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip label={option} {...getTagProps({ index })} key={option} deleteIcon={<CloseIcon/>}/>
                                    ))
                                }
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        sx={{
                                            fieldset: { border: "none" }, // Убираем рамку
                                            '& .MuiChip-root': {
                                                height: '26px',
                                                borderRadius: '0 !important',
                                            }
                                        }}
                                        placeholder= {jobType.length === 0 ? "Select job type": ""}
                                    />
                                )}
                            />
                            <Box display="flex" alignItems="center" sx={{my: 2,ml:2,mr:4}}>
                                <ToggleButtonGroup
                                    color="primary"
                                    value={dateFilter}
                                    exclusive
                                    onChange={handleChange}
                                    aria-label="date_filter_btns"
                                >
                                    <ToggleButton variant="text" className="chip_filter_btn" sx={{mx: 1}} value="all_times">All times</ToggleButton>
                                    <ToggleButton variant="text" className="chip_filter_btn" sx={{mx: 1}} value="this_year">This year</ToggleButton>
                                    <ToggleButton variant="text" className="chip_filter_btn" sx={{mx: 1}} value="this_week">This week</ToggleButton>
                                    <ToggleButton variant="text" className="chip_filter_btn" sx={{mx: 1}} value="last_30_days">Last 30 days</ToggleButton>
                                </ToggleButtonGroup>
                            </Box>
                        </>
                        }
                            <Box>
                                <LocalizationProvider dateAdapter={AdapterDayjs}>
                                    <DemoContainer components={['DatePicker','DatePicker']}>
                                        <DatePicker
                                            className="date_picker_field"
                                            label="Since"
                                            format="DD, MMMM, YYYY"
                                            slots={{
                                                openPickerIcon: CalendarMonthOutlinedIcon
                                            }}
                                        />
                                        <DatePicker
                                            className="date_picker_field"
                                            label="Until"
                                            format="DD, MMMM, YYYY"
                                            slots={{
                                                openPickerIcon: CalendarMonthOutlinedIcon
                                            }}
                                        />
                                    </DemoContainer>
                                </LocalizationProvider>
                            </Box>
                        <Box display={'flex'} sx={{p: 1,ml:3}}>
                            <Button sx={{mr: 0}}
                                    className="Campaign_btn"
                                    onClick={() => dispatch(openModal({
                                        content: <TaskListFilterContent/>,
                                        style: {width: '780px'}
                                    }))}
                            >
                                <Badge badgeContent={1} // TODO check this
                                       color="primary"
                                       sx={{mr: 2}}
                                       className="filter_count"
                                >
                                    <FilterAltOutlined sx={{fontSize: '24px'}}/>
                                </Badge> filters
                            </Button>
                            <Typography variant="div" component="span"
                                        className="count_campaign_step count_campaign_step_right">
                                1
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Container>
        </>
    )
}
